import { useQuery } from "@tanstack/react-query"
import { createContext, ReactNode, useContext, useEffect } from "react"
import { getPolicyPublic } from "../../utils"
import { PolicyPublic } from "../../client"


const SettingsContext = createContext<PolicyPublic | null>(null)

export function SettingsProvider({ children }: { children: ReactNode }) {
    const { data: settings } = useQuery({
        ...getPolicyPublic(),
    })

    // Apply CSS variables for theme colors
    useEffect(() => {
        if (!settings) return

        const root = document.documentElement
        if(settings?.main_color) root.style.setProperty(`--main`, settings.main_color)
        if(settings?.secondary_color) root.style.setProperty(`--secondary`, settings.secondary_color)
        if(settings?.tertiary_color) root.style.setProperty(`--tertiary`, settings.tertiary_color)
    }, [settings])

    return (
        <SettingsContext.Provider value={settings ?? null}>
            {children}
        </SettingsContext.Provider>
    )
}

export function useSettings() {
    return useContext(SettingsContext)
}